// Aide au suivi des événements du tunnel Penlab (devis, calculateur, quiz, guide, promo).
// N'envoie rien si Google Analytics n'est pas chargé (donc pas de consentement) : pas de file d'attente,
// on respecte simplement le choix du visiteur.
window.penlabTrack = function (eventName, params) {
  try {
    if (typeof window.gtag === 'function') {
      var finalParams = params || {};
      // Attache automatiquement l'attribution commerciale (rep_id uniquement, jamais de donnee
      // personnelle visiteur) a tous les evenements, quand elle existe.
      if (window.PenlabSalesRepAttribution && window.PenlabSalesRepAttribution.rep_id) {
        finalParams = Object.assign({ rep_id: window.PenlabSalesRepAttribution.rep_id }, finalParams);
      }
      window.gtag('event', eventName, finalParams);
    }
  } catch (e) {}
};

document.addEventListener('DOMContentLoaded', function () {
  // Clic sur l'offre Rentrée (bandeau d'annonce ou liens vers la page offre)
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="/pages/offre-rentree"]');
    if (link) {
      window.penlabTrack('promo_click', { promo_code: 'RENTREE' });
    }
  });
});

